import TicketsForFundraisingDatagrid from '../DatagridEntity/TicketsForFundraisingDatagrid';

const FundraisingTicketsPage = () => (<TicketsForFundraisingDatagrid />);
export default FundraisingTicketsPage;
